/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WarmupDTO
 */
export interface WarmupDTO {
    /**
     * 
     * @type {Date}
     * @memberof WarmupDTO
     */
    date: Date;
    /**
     * 
     * @type {number}
     * @memberof WarmupDTO
     */
    timeSpent: number;
}

/**
 * Check if a given object implements the WarmupDTO interface.
 */
export function instanceOfWarmupDTO(value: object): value is WarmupDTO {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('timeSpent' in value) || value['timeSpent'] === undefined) return false;
    return true;
}

export function WarmupDTOFromJSON(json: any): WarmupDTO {
    return WarmupDTOFromJSONTyped(json, false);
}

export function WarmupDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WarmupDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'date': (new Date(json['date'])),
        'timeSpent': json['timeSpent'],
    };
}

export function WarmupDTOToJSON(json: any): WarmupDTO {
    return WarmupDTOToJSONTyped(json, false);
}

export function WarmupDTOToJSONTyped(value?: WarmupDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'].toISOString().substring(0,10),
        'timeSpent': value['timeSpent'],
    };
}

